<template>
    <div class="box my-2 px-0 pb-0">
        <div class="level px-5">
            <div class="level-left">
                <div class="level-item">
                    <p class="title is-size-6">
                        {{ question.title }}
                    </p>
                </div>
            </div>
            <div class="level-right">
                <span class="level-item">
                    <p class="title has-text-weight-bold is-5 has-text-primary">
                        {{ question.hitRate }}
                    </p>
                    <p v-t="'Sessions.question_hit_rate'" class="pl-3"></p
                ></span>
            </div>
        </div>
        <div class="columns mx-0 my-0">
            <div
                class="
                    column
                    is-one-fifth-widescreen
                    is-one-quarter-desktop
                    is-one-third-tablet
                "
                :style="`${background}`"
                :class="$mq == 'mobile' ? 'has-fixed-height' : ''"
            ></div>

            <div
                class="
                    column
                    px-0
                    py-0
                    is-four-fifth-widescreen
                    is-three-quarter-desktop
                    is-two-third-tablet
                "
            >
                <div
                    v-if="
                        !question.answerType ||
                        question.answerType == 'SINGLE' ||
                        question.answerType == 'MULTIPLE'
                    "
                    class="lb-question-answers"
                >
                    <div
                        v-for="(answer, index) in question.answers"
                        :key="index"
                        class="is-relative pl-4 is-bordered pt-1 pb-1"
                    >
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2">
                                        <span
                                            class="
                                                icon
                                                is-medium is-vertical-center
                                            "
                                            :class="
                                                answer.correct == true
                                                    ? 'has-text-success'
                                                    : 'has-text-black'
                                            "
                                        >
                                            <i
                                                :class="
                                                    answer.correct == true
                                                        ? 'mdi-check'
                                                        : 'mdi-close'
                                                "
                                                class="mdi mdi-18px"
                                            ></i>
                                        </span>
                                        <span
                                            v-if="answerSelectedByUser(answer)"
                                            class="icon is-small"
                                        >
                                            <i class="fas fa-user" />
                                        </span>
                                        {{ answer.value }}
                                    </p>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="py-2 pr-5">
                                        {{ question.stats[answer.value] || 0 }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="
                        question.answerType == 'HANGMAN' ||
                        question.answerType == 'FREETEXT'
                    "
                    class="lb-question-answers"
                >
                    <div class="is-relative pl-4 pb-5 mb-3 pt-2">
                        <div
                            v-if="question.answerType == 'HANGMAN'"
                            class="
                                columns
                                is-multiline is-mobile is-variable is-1
                            "
                        >
                            <div
                                v-for="(letter, index) in question.answers[0]
                                    .value"
                                :key="index"
                                class="column is-narrow"
                            >
                                <div class="lb-hangman-input-letter has-shadow">
                                    <p
                                        class="
                                            has-text-weight-bold
                                            is-size-3
                                            pb-1
                                        "
                                    >
                                        {{ letter }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-else class="is-freetext">
                            <p class="is-size-4 is-italic has-text-weight-bold">
                                " {{ question.answers[0].value }} "
                            </p>
                        </div>
                    </div>
                    <div class="is-relative pl-4 is-bordered pb-1 pt-1">
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2 pt-1 pb-1">
                                        {{ $t('Sessions.correct') }}
                                    </p>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="py-2 pr-5">
                                        {{ correctAnswersCount }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="is-relative pl-4 is-bordered pb-1 pt-1">
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2">
                                        {{ $t('Sessions.incorrect') }}
                                    </p>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="py-2 pr-5">
                                        {{ incorrectAnswersCount }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    props: {
        question: {
            type: Object,
            default: () => {},
        },
        userAnswer: {
            type: [Array, String],
            default: () => {
                return [];
            },
        },
        correctAnswersCount: {
            type: Number,
            default: 0,
        },
        incorrectAnswersCount: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {};
    },
    computed: {
        questionImage() {
            return this.question.images && this.question.images.length
                ? this.question.images[0].url
                : process.env.VUE_APP_ROOT_URL + '/img/empty.png';
        },
        totalAnswers() {
            return _.chain(this.question.stats)
                .values()
                .reduce((memo, num) => {
                    return memo + +num;
                }, 0)
                .value();
        },
        answerSelectedByUser() {
            return (answer) => {
                if (this.question.answerType == 'MULTIPLE') {
                    return !!_.where(this.userAnswer, answer).length;
                } else {
                    return answer.value == this.userAnswer;
                }
            };
        },
        background() {
            return `background-image:url(${this.questionImage});background-size:cover;background-repeat: no-repeat; background-position: center;`;
        },
    },

    methods: {},
    mounted() {
        // console.log(this.correctAnswersCount, this.incorrectAnswersCount);
    },
};
</script>

<style scoped>
img {
    object-fit: cover;
}
.lb-question-image {
    width: 270px;
    height: 160px;
}
.lb-question-container {
    align-items: flex-start;
    display: flex;
}
@media only screen and (max-width: 768px) {
    .lb-question-container {
        display: initial;
    }
    .lb-question-image {
        width: 100%;
        height: 160px;
    }
}

.lb-question-container > figure {
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
}
.lb-question-container > .lb-question-answers {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
}
.questions-progress {
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    position: absolute;
}
.box {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}
.is-bordered {
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
}
.is-vertical-center {
    vertical-align: middle;
}
.lb-hangman-input-letter {
    height: auto;
}
.is-freetext {
    height: 3.3rem;
}
.has-fixed-height {
    height: 160px;
}
</style>
